import { DefaultTheme } from "styled-components";

export const theme:DefaultTheme = {
    bgColor: "#ffffff",
    textColor: "black",
    borderRadius: "15"
}